import { productCarouselProductStyles } from "@insite/content-library/Components/ProductCarouselProduct";
import { productCarouselStyles } from "@insite/content-library/Widgets/Common/ProductCarousel";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productCarouselStyles.mainContainer = {
    css: css`
        margin: 15px auto 35px;
        > div[class^="GridOffset"] {
            max-width: 100%;
            margin: 0 auto;
        }
    `,
};
productCarouselStyles.carouselSlide = {
    css: css`
        position: relative;
        flex: 0 0 auto;
        padding: 0px 10px;
        > div[data-test-selector="productContainer"] {
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            background: #fff;
            padding: 10px;
            border: ${getColor("common.border")} 1px solid;
        }
    `,
};

productCarouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        height: 100%;
        position: relative;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        &:hover {
            box-shadow: 0px 0px 10px 1px #ccc;
        }
    `,
};

productCarouselStyles.carouselGridItem = {
    width: 10,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 96%;
                    max-width: 96%;
                `,
                css`
                    flex-basis: 96%;
                    max-width: 96%;
                `,
                css`
                    flex-basis: 96%;
                    max-width: 96%;
                `,
                css`
                    flex-basis: 96%;
                    max-width: 96%;
                `,
                css`
                    flex-basis: 96%;
                    max-width: 96%;
                `,
            ])}
    `,
};

productCarouselStyles.nextArrowGridItem = {
    width: 1,
    align: "middle",
    css: css`
        justify-content: flex-end;
        padding: 0 10px 0 0;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 2%;
                    max-width: 2%;
                    padding: 0;
                `,
                css`
                    flex-basis: 2%;
                    max-width: 2%;
                    padding: 0;
                `,
                css`
                    flex-basis: 2%;
                    max-width: 2%;
                    padding: 0;
                `,
                css`
                    flex-basis: 2%;
                    max-width: 2%;
                `,
                css`
                    flex-basis: 2%;
                    max-width: 2%;
                `,
            ])}
    `,
};
productCarouselStyles.nextArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 0;
        border: #e4e4e4 2px solid;
        z-index: 1;
        &:hover {
            border: ${getColor("text.main")} 2px solid;
        }
    `,
};

productCarouselStyles.prevArrowGridItem = {
    width: 1,
    align: "middle",
    css: css`
        justify-content: flex-start;
        padding: 0 0 0 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 2%;
                    max-width: 2%;
                    padding: 0;
                `,
                css`
                    flex-basis: 2%;
                    max-width: 2%;
                    padding: 0;
                `,
                css`
                    flex-basis: 2%;
                    max-width: 2%;
                    padding: 0;
                `,
                css`
                    flex-basis: 2%;
                    max-width: 2%;
                `,
                css`
                    flex-basis: 2%;
                    max-width: 2%;
                `,
            ])}
    `,
};

productCarouselStyles.prevArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 0;
        border: #e4e4e4 2px solid;
        z-index: 1;
        &:hover {
            border: ${getColor("text.main")} 2px solid;
        }
    `,
};

productCarouselProductStyles.productImageStyles = {
    image: {
        css: css`
            height: 270px;
            align-items: center;
            justify-content: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            height: auto !important;
                            max-height: 270px !important;
                        `,
                        null,
                        css`
                            height: 210px;
                        `,
                        null,
                    ],
                    "max",
                )};
            img {
                height: auto;
                min-width: auto;
                max-height: 270px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                height: auto;
                                max-height: 270px !important;
                            `,
                            null,
                            css`
                                height: auto;
                                max-height: 210px;
                            `,
                            null,
                        ],
                        "max",
                    )};
            }
        `,
    },
};

productCarouselProductStyles.productBrandWrapper = {
    css: css`
        margin: 10px 0 0 0;
        min-height: 22px;
    `,
};

productCarouselProductStyles.productDescriptionStyles = {
    productDetailLink: {
        css: css`
            margin: 10px 0;
            flex-grow: 1;
            align-items: flex-start;
            span {
                color: #333 !important;
                font-weight: 600;
                font-size: 18px;
            }
        `,
    },
};

productCarouselProductStyles.productPriceWrapper = {
    css: css`
        flex-grow: 0;
        margin-bottom: 10px;
        border-bottom: ${getColor("common.border")} 1px solid;
        section {
            margin-bottom: 5px;
        }
        span[data-test-selector="productPrice_unitNetPrice"] {
            color: ${getColor("primary")};
        }
    `,
};

productCarouselProductStyles.qtyGridItem = {
    width: 3,
    css: css`
        input[data-test-selector="product_qtyOrdered"] {
            border: 1px solid #e4e4e4;
            border-radius: 2px !important;
            text-align: center;
        }
    `,
};

productCarouselProductStyles.productAddToCartButtonStyles = {
    css: css`
        width: 100%;
        border-radius: 2px;
        span {
            text-transform: uppercase;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            font-size: 14px;
                        `,
                        null,
                    ],
                    "max",
                )}
        }
    `,
};
